module.exports = __webpack_public_path__ + "img/2024517-num2.7213e7d.svg";